/** Montant en FCFA, avec espaces fines : 12 500 F */
export function fcfa(v, suffixe = true) {
  const n = Math.round(Number(v) || 0);
  return n.toLocaleString("fr-FR").replace(/ | /g, " ") + (suffixe ? " F" : "");
}

/** Quantité : jusqu'à 3 décimales, virgule française. */
export function qte(v) {
  const n = Number(v) || 0;
  return n.toLocaleString("fr-FR", { maximumFractionDigits: 3 }).replace(/ | /g, " ");
}

export function date(v, avecHeure = false) {
  if (!v) return "—";
  const d = new Date(String(v).replace(" ", "T"));
  if (isNaN(d)) return v;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) + (avecHeure ? " " + d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");
}

export function heure(v) {
  if (!v) return "";
  const d = new Date(String(v).replace(" ", "T"));
  return d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

export function aujourdhui(decalageJours = 0) {
  const d = new Date();
  d.setDate(d.getDate() + decalageJours);
  return d.toISOString().slice(0, 10);
}

export function debutMois() {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1, 12).toISOString().slice(0, 10);
}

/** Saisie « 1,5 » → 1.5 */
export function nombre(v) {
  return Number(String(v ?? "").replace(/\s/g, "").replace(",", ".")) || 0;
}

export const LIBELLES = {
  statutPaiement: { PAYEE: "Payée", PARTIELLE: "Partielle", NON_PAYEE: "À crédit" },
  tarif: { DETAIL: "Détail", DEMI_GROS: "Demi-gros", GROS: "Gros" },
  achat: { BROUILLON: "Brouillon", COMMANDE: "Commandé", PARTIEL: "Reçu en partie", RECU: "Reçu", ANNULE: "Annulé" },
  transfert: { BROUILLON: "Brouillon", EXPEDIE: "En route", RECU: "Reçu", ANNULE: "Annulé" },
  inventaire: { EN_COURS: "En cours", VALIDE: "Validé", ANNULE: "Annulé" },
  devis: { BROUILLON: "Brouillon", ENVOYE: "Envoyé", ACCEPTE: "Accepté", REFUSE: "Refusé", CONVERTI: "Facturé" },
  lot: { EXPIRE: "Périmé", CRITIQUE: "Périme sous 7 j", PROCHE: "Bientôt périmé", OK: "Bon", SANS_DATE: "Sans date" },
  site: { BOUTIQUE: "Boutique", DEPOT: "Dépôt" },
};

/** Exporte un tableau en CSV (Excel FR : point-virgule, BOM UTF-8). */
export function exporterCsv(nom, entetes, lignes) {
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const contenu = "﻿" + [entetes, ...lignes].map(l => l.map(esc).join(";")).join("\n");
  const url = URL.createObjectURL(new Blob([contenu], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = nom;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

/** Libellé court d'un code d'unité (PIECE → pce, KG → kg, CARTON → carton). */
const UNITES_COURTES = { PIECE: "pce", UNITE: "u", KG: "kg", G: "g", L: "l", ML: "ml", M: "m", M2: "m²", M3: "m³", T: "t" };
export function unite(code) {
  const c = String(code || "").toUpperCase();
  return UNITES_COURTES[c] || c.toLowerCase();
}
